import { Button, Typography } from '@breetometer/components';
import { ArrowIcon } from 'BreetAssets';

import type { IAvailableAccount } from './DialogSwitchUserAccount.helpers';

const AvailableAccount = ({ accountName, accountRole, onClick, isLoading }: IAvailableAccount) => (
	<Button
		variant='native'
		className='list-item'
		onClick={onClick}
	>
		<div className='list-item-left'>
			<div className='list-item-txt'>
				<Typography as='h6'>{accountName}</Typography>
				<Typography>{accountRole}</Typography>
			</div>
		</div>

		{isLoading ? <div /> : <ArrowIcon variant='arrowRight' />}
	</Button>
);

export default AvailableAccount;
